import type SVGProps from '~/components/icons/svg-props'

export type ArrowLeftIconProps = SVGProps & {
  variant?: 'outlined' | 'filled'
}

export default function ArrowLeftIcon(props: ArrowLeftIconProps) {
  const { variant, width = '24', height = '24', ...rest } = props
  return variant === 'filled' ? (
    <ArrowLeftIconFilled width={width} height={height} {...rest} />
  ) : (
    <ArrowLeftIconOutlined width={width} height={height} {...rest} />
  )
}

function ArrowLeftIconOutlined(props: SVGProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7905 6.14446C15.0421 6.36011 15.0712 6.73889 14.8555 6.99048L10.3902 12.2L14.8555 17.4095C15.0712 17.6611 15.0421 18.0399 14.7905 18.2555C14.5389 18.4712 14.1601 18.4421 13.9444 18.1905L9.14445 12.5905C8.95185 12.3658 8.95185 12.0342 9.14445 11.8095L13.9444 6.20954C14.1601 5.95794 14.5389 5.9288 14.7905 6.14446Z"
        fill="currentColor"
      />
    </svg>
  )
}

function ArrowLeftIconFilled(props: SVGProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7905 6.14446C15.0421 6.36011 15.0712 6.73889 14.8555 6.99048L10.3902 12.2L14.8555 17.4095C15.0712 17.6611 15.0421 18.0399 14.7905 18.2555C14.5389 18.4712 14.1601 18.4421 13.9444 18.1905L9.14445 12.5905C8.95185 12.3658 8.95185 12.0342 9.14445 11.8095L13.9444 6.20954C14.1601 5.95794 14.5389 5.9288 14.7905 6.14446Z"
        fill="currentColor"
      />
    </svg>
  )
}
